import {Injectable} from '@angular/core';
import {UsersService} from '../api/services/users.service';
import {BehaviorSubject} from 'rxjs';
import {TagsService as ApiTagsService} from '../api/services/tags.service';
import {TagModel, TagsGridResponse, TagsRequest} from '../api/models';

@Injectable()
export class TagsService {
  tagsList = new BehaviorSubject<TagsGridResponse | undefined>(undefined);

  constructor(private apiUserService: UsersService,
              private apiTagsService: ApiTagsService
  ) {

  }

  public async getTags(state: TagsRequest): Promise<void> {
    console.log(state);
    const response = await this.apiTagsService.tagsGetTagsForGrid({body: state}).toPromise();

    this.tagsList.next(response);
  }

  public async saveTag(model: TagModel): Promise<boolean> {
    await this.apiTagsService.tagsSaveTag({body: model}).toPromise();

    return true;
  }

  public async deleteTag(id: string): Promise<boolean> {
    await this.apiTagsService.tagsDeleteTagById({id: id}).toPromise();

    return true;
  }
}
